import { Loading } from "@/layouts/loading";
import { createRootRoute, Outlet, redirect } from "@tanstack/react-router";

export const Route = createRootRoute({
    component: () => <Outlet />,
    loader: ({ location }) => {
      if (location.pathname === '/') {
        // Check for stored credentials
        const accessToken = localStorage.getItem('accessToken');
        const userStr = localStorage.getItem('user');
        
        if (accessToken && userStr) {
          try {
            const user = JSON.parse(userStr);
            const userRole = user.role?.toLowerCase();
            
            // Role-based automatic redirect
            if (userRole === 'admin') {
              throw redirect({ to: '/dashboard' });
            } else if (userRole === 'manager') {
              throw redirect({ to: '/manager/dashboard' });
            } else if (userRole === 'technician') {
              throw redirect({ to: '/technician' });
            }
          } catch (error) {
            console.error('Error parsing user data:', error);
            // If parsing fails, clear invalid data and redirect to login
            localStorage.removeItem('accessToken');
            localStorage.removeItem('refreshToken');
            localStorage.removeItem('user');
          }
        }
        
        // Default redirect to login if no valid credentials
        throw redirect({ to: '/login' });
      }
    },
    pendingComponent: () => <Loading />,
    pendingMinMs: 1000,
    pendingMs: 1,
});